<template>
    <div>
        <div class="relationalDatabaseServiceResource-title">
            <div>RDS</div>
            <div>
                <Button type="primary" :loading="modal_loading" @click="exportList" v-hasPermission="['resourceConfigurationManagement:aws:reservedInstanceResource:rds:export']">{{ $t('common.export') }}</Button>
            </div>
        </div>
        <div class="relationalDatabaseServiceResource-top">
            <relational-database-service-resource-search ref="relationalDatabaseServiceResourceSearchChild"></relational-database-service-resource-search>
        </div>
        <table-relational-database-service-resource></table-relational-database-service-resource>
    </div>
</template>

<script>
    import RelationalDatabaseServiceResourceSearch from '../rds/RelationalDatabaseServiceResourceSearch'
    import TableRelationalDatabaseServiceResource from '../rds/TableRelationalDatabaseServiceResource'

    export default {
        name: 'RelationalDatabaseServiceResource',
        components: {
            RelationalDatabaseServiceResourceSearch,
            TableRelationalDatabaseServiceResource
        },
        data () {
            return {
                modal_loading: false,
                accountIds: [],
                regions: [],
                offeringType: '',
                awsId: '',
                expiration: '',
                state: ''
            }
        },
        methods: {
            //导出
            exportList: function () {
                // 获取子组件数据
                this.awsId = this.$refs.relationalDatabaseServiceResourceSearchChild.awsId;
                this.accountIds = this.$refs.relationalDatabaseServiceResourceSearchChild.accountIds;
                this.regions = this.$refs.relationalDatabaseServiceResourceSearchChild.regions;
                this.offeringType = this.$refs.relationalDatabaseServiceResourceSearchChild.offeringType;
                this.state = this.$refs.relationalDatabaseServiceResourceSearchChild.state;
                this.expiration = this.$refs.relationalDatabaseServiceResourceSearchChild.expiration;

                if (this.accountIds == "" || this.accountIds == null) {
                    this.$Message.warning("请选择账号", 5)
                    return;
                }
                if (this.regions == "" || this.regions == null) {
                    this.$Message.warning("请选择区域", 5)
                    return;
                }

                this.modal_loading = true
                this.$Message.loading({
                  duration: 0,
                  content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.reservedInstance.exportReservedDBInstance({
                   "initAccountType": 2,
                    "accountId": this.awsId,
                    "accountIds": this.accountIds,
                    "regions": this.regions,
                    "offeringType": this.offeringType,
                    "expiration": this.expiration,
                    "state": this.state
                })
                .then(res => {
                    let fileName = 'RDS预留实例.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    this.modal_loading = false;
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            }
        }
    }
</script>

<style scoped>
    .relationalDatabaseServiceResource-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        overflow: hidden;
        font-weight: 600;
    }
    .relationalDatabaseServiceResource-title>div:nth-child(1)
    {
        float:left;
    }
    .relationalDatabaseServiceResource-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .relationalDatabaseServiceResource-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/rds/RelationalDatabaseServiceResource.vue